import { Bar, BarButton } from './ui/Bar';
import PencilSizeIcon from '../assets/design/pencil-size.svg';
import PencilSizeActiveIcon from '../assets/design/pencil-size-active.svg';
import PencilColourIcon from '../assets/design/pencil-colour.svg';
import PencilColourActiveIcon from '../assets/design/pencil-colour-active.svg';
import MoveIcon from '../assets/design/move.svg';
import MoveActiveIcon from '../assets/design/move-active.svg';
import ShapesIcon from '../assets/design/shapes.svg';
import ShapesActiveIcon from '../assets/design/shapes-active.svg';
import GridIcon from '../assets/design/grid.svg';
import GridActiveIcon from '../assets/design/grid-active.svg';
import FillIcon from '../assets/design/fill.svg';
import FillActiveIcon from '../assets/design/fill-active.svg';
import SaveImageIcon from '../assets/design/save-image.svg';
import SaveImageActiveIcon from '../assets/design/save-image-active.svg';

export type ToolKey = 'size' | 'colour' | 'move' | 'shapes' | 'grid' | 'fill' | 'save';

export const TOOLBAR: { key: ToolKey; label: string; icon: string; activeIcon: string }[] = [
	{ key: 'size', label: 'Pencil\nsize', icon: PencilSizeIcon, activeIcon: PencilSizeActiveIcon },
	{ key: 'colour', label: 'Pencil\ncolour', icon: PencilColourIcon, activeIcon: PencilColourActiveIcon },
	{ key: 'move', label: 'Move\ncanvas', icon: MoveIcon, activeIcon: MoveActiveIcon },
	{ key: 'shapes', label: 'Shapes', icon: ShapesIcon, activeIcon: ShapesActiveIcon },
	{ key: 'grid', label: 'Grid', icon: GridIcon, activeIcon: GridActiveIcon },
	{ key: 'fill', label: 'Fill', icon: FillIcon, activeIcon: FillActiveIcon },
	{ key: 'save', label: 'Save\nimage', icon: SaveImageIcon, activeIcon: SaveImageActiveIcon },
];

export type DrawingToolbarProps = {
	isActive: (key: ToolKey) => boolean;
	onSelect: (key: ToolKey) => void;
};

/** Fixed tool bar under the canvas (style guide "Drawing Tools"). */
function DrawingToolbar({ isActive, onSelect }: DrawingToolbarProps) {
	return (
		<Bar role="toolbar" aria-label="Drawing tools">
			{TOOLBAR.map(tool => {
				const active = isActive(tool.key);
				return <BarButton key={tool.key} icon={active ? tool.activeIcon : tool.icon} label={tool.label} active={active} onClick={() => onSelect(tool.key)} />;
			})}
		</Bar>
	);
}

export default DrawingToolbar;
